import { Dialog } from 'antd-mobile';
import VConsole from 'vconsole';
import { Storage } from '../Storage';
export const GrtDialog = {
    confirm: (config) => {
        Dialog.confirm({
            ...config,
            cancelText: config.cancelText || <span style={{ color: '#999999' }}>取消</span>
        });
    },
    alert: (config) => {
        Dialog.alert({
            ...config,
            cancelText: config.cancelText || <span style={{ color: '#999999' }}>取消</span>
        });
    },
    clear: () => {
        Dialog.clear();
    }
};

let lastTime = 0,
    count = 0,
    maxCount = 20,
    interval = 500;
export const openConsole = () => {
    const date = new Date();
    if (date.getTime() - lastTime > interval) {
        lastTime = 0;
    }
    if (count === 0) {
        count++;
        lastTime = date.getTime();
        return;
    }
    const currentInterval = date.getTime() - lastTime;
    if (currentInterval < interval) {
        if (count > maxCount - 1) {
            if (!window.vConsole) {
                window.vConsole = new VConsole();
            }
            count = 0;
            lastTime = 0;
            return;
        }

        count++;
        lastTime = date.getTime();
        return;
    }
    count = 0;
    lastTime = 0;
};
export const openEgg = (cb) => {
    const date = new Date();
    if (date.getTime() - lastTime > interval) {
        lastTime = 0;
    }
    if (count === 0) {
        count++;
        lastTime = date.getTime();
        return;
    }
    const currentInterval = date.getTime() - lastTime;
    if (currentInterval < interval) {
        if (count > maxCount - 1) {
            cb();
            count = 0;
            lastTime = 0;
            return;
        }

        count++;
        lastTime = date.getTime();
        return;
    }
    count = 0;
    lastTime = 0;
};
export const getOS = () => {
    let ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf('micromessenger') > -1) {
        return 'wx';
    }
    if (ua.indexOf('android') > -1 || ua.indexOf('linux') > -1) {
        return 'android';
    }
    if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        return 'ios';
    }

    return 'others';
};
let originalHeight = window.innerHeight;
export const handleKeyboardHeightChange = () => {
    window.addEventListener('resize', () => {
        const currentHeight = window.innerHeight;
        const keyboardHeight = originalHeight - currentHeight;

        if (keyboardHeight > 50) {
            // 键盘弹出
            document.body.style.paddingBottom = `${keyboardHeight}px`;
        } else {
            // 键盘收起
            document.body.style.paddingBottom = '0';
        }
    });
};
export const linkApp = (params) => {
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(params);
};

export const isInApp = () => {
    let urlSearch = new URLSearchParams(window.location.search);
    let ufoAgent = urlSearch.get('ufo-agent');
    if (ufoAgent === 'grtedu') {
        return true;
    }
    const localInApp = Storage.get('inApp');
    if (localInApp) return localInApp;

    return false;
};
export const goAppLogin = () => {
    linkApp('grtedu://login?go-login=mobile');
};

export const envMap = {
    app: 'app',
    h5: 'h5',
    pc: 'pc'
};
export const isInIframe = () => {
    return window.top !== window.self;
};
export const getEnvironment = () => {
    // 1. 优先判断是否在APP内
    if (isInApp()) {
        return 'app';
    }
    const urlSearch = new URLSearchParams(window.location.search);
    const env = urlSearch.get('env');
    if (env === 'app' || env === 'h5' || env === 'pc') {
        return env;
    }
    const localEnv = Storage.get('environment');
    if (isInIframe()) {
        if (localEnv) return localEnv;
    } else {
        Storage.remove('environment');
        return null;
    }
    return null;
};

//处理移动端配置--根据url参数设置环境、userAgent、Authorization，把清除逻辑注释了是因为页面跳转时，可能不带着这些参数，如果清除了，会出问题
export const handleMobileConfig = async () => {
    const urlSearch = await new URLSearchParams(window.location.search);
    const ufoAgent = urlSearch.get('ufo-agent');
    const userAgent = urlSearch.get('user-agent');
    console.log('userAgent', userAgent);
    const env = ufoAgent === 'grtedu' ? 'app' : urlSearch.get('env');
    const Authorization = urlSearch.get('Authorization') || Storage.get('grtToken');

    //嵌入在app
    if (ufoAgent === 'grtedu') {
        Storage.set('inApp', true);
    } else {
        Storage.remove('inApp');
    }
    //嵌入在其他环境--包括app
    if (env === 'app' || env === 'h5' || env === 'pc' || env === 'app') {
        Storage.set('environment', env);
    } else {
        //判断是在iframe中打开还是单独打开
        if (!isInIframe()) {
            Storage.remove('environment');
        }
    }
    //userAgent
    if (userAgent) {
        Storage.set('userAgent', userAgent);
    } else {
        if (env !== 'app') {
            Storage.remove('userAgent');
        }
    }
    //Authorization
    if (Authorization) {
        Storage.set('Authorization', Authorization);
    } else {
        if (!isInIframe() && env !== 'app') {
            Storage.remove('Authorization');
        }
    }
};
